import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../service/auth/auth.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'topnavbar-profile',
  templateUrl: './topnavbar-profile.component.html',
  styleUrls: ['./topnavbar-profile.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    ToastrModule,
    RouterModule,
  ],
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class TopnavbarProfileComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly toastr = inject(ToastrService);
  private readonly elRef = inject(ElementRef);
  readonly router = inject(Router);

  openProfile = false;
  name = '';
  profileUser = '';
  firstCharacters = '';

  ngOnInit(): void {
    this.name = localStorage.getItem('name') ?? '';
    this.profileUser = localStorage.getItem('user') ?? '';
    this.firstCharacters = this.extractFirstCharacters();
  }

  extractFirstCharacters(): string {
    return this.name
      .split(' ')
      .slice(0, 2)
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase();
  }

  toggleProfile(): void {
    this.openProfile = !this.openProfile;
  }

  onDocumentClick(event: MouseEvent): void {
    if (!this.openProfile) return;
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.openProfile = false;
    }
  }

  handleExit(): void {
    this.openProfile = false;
    this.auth.removeLocalStorage();
    this.router.navigate(['/autenticacao/login']);
    this.toastr.show('Logout efetuado com sucesso!', 'Sucesso!', {
      timeOut: 5000,
      messageClass: 'success',
      titleClass: JSON.stringify({}),
    });
  }
}
